
import { Component, Mixins } from "vue-property-decorator";
import { EditingDocument } from "..";

@Component
export default class DocumentPageNavigatableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: EditingDocument) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: EditingDocument) => T, defaultValue: T) => T;

  get pageCount(): number {
    // TODO: 将来的には複数ページ/セクション対応も考慮要.
    return this.readPropertyOrDefault(s => s.sections.length, 0);
  }

  get currentPage(): number {
    // TODO: 将来的には複数ページ/セクション対応も考慮要.
    return this.readPropertyOrDefault(s => s.currentSectionIndex, -1) + 1;
  }

  set currentPage(source: number) {
    // TODO: 将来的には複数ページ/セクション対応も考慮要.
    this.writePropertyWhenValid(s => s.currentSectionIndex = source - 1);
  }

  get isSourceAlreadyInitialized(): boolean {
    return this.readPropertyOrDefault(d => d.isAlreadyInitialized, false);
  }
}
